import {Component, OnDestroy, OnInit} from '@angular/core';
import {OrganizationService} from '../../service/organization.service';
import {UserService} from '../../service/user.service';

@Component({
  selector: 'app-organizations',
  templateUrl: './organizations.component.html',
  styleUrls: ['./organizations.component.scss']
})
export class OrganizationsComponent implements OnInit, OnDestroy {

  public data = {
    organizations: null
  };

  public filter = {
    searchText: null,
    column: null
  };

  public sort = {
    column: null,
    direction: null
  };

  public paginationConfig = {
    total: 0,
    pageIndex: null,
    pageSize: null
  };

  public retrievingData = true;
  public currentUser;

  private newOrganisationObserver;
  private organisationsObserver;
  private searchObserver;

  constructor(private orgService: OrganizationService,
              private userService: UserService) {
    this.data = { organizations: [] };
    this.filter = { searchText: '', column: 'title' };
    this.sort = { column: 'title', direction: null };
    this.paginationConfig = { total: 0, pageIndex: 1, pageSize: 10 };
  }

  ngOnInit() {
    this.currentUser = this.userService.currentUserSubject.getValue();

    this.organisationsObserver = this.orgService
      .getOrganizations(null, 'table')
      .subscribe(organizations => {
          if (organizations) {
            this.data = { organizations };
          }

          this.retrievingData = false;
        });

    this.newOrganisationObserver = this.orgService.newOrgSubject
      .subscribe((newOrganisation) => {
        if (newOrganisation) {
          this.data = { organizations: [...this.data.organizations, newOrganisation] };
        }
      });

    this.searchObserver = this.userService.newSearchSubject
      .subscribe((text) => {
        this.paginationConfig.pageIndex = 1;
        this.filter.searchText = text;
        this.data = {...this.data};
      });
  }

  ngOnDestroy() {
    this.organisationsObserver.unsubscribe();
    this.newOrganisationObserver.unsubscribe();
    this.searchObserver.unsubscribe();
  }

  onSetOrder(selectedColumn) {
    this.paginationConfig.pageIndex = 1;

    if (this.sort.column === selectedColumn) {
      if (this.sort.direction === null) {
        this.sort.direction = 'reverse';
      } else {
        this.sort.direction = null;
      }
    }
    this.sort.column = selectedColumn;
  }

  deleteOrganisation(organisation) {
    if (confirm(`Are you sure you want to delete ${organisation.title}?`)) {
      const index = this.data.organizations.indexOf(organisation);
      this.data.organizations.splice(index, 1);

      this.orgService.deleteOrg(organisation)
        .subscribe(value => {
          this.data = {...this.data};
        });
    }
  }

  getCellRouterLink(organisationId): string[] {
    return this.currentUser.role === 'superadmin'
      ? ['/main/organisations', organisationId]
      : [];
  }

  onPageChange(pageIndex) {
    this.paginationConfig.pageIndex = pageIndex;
  }

  getPaginationStart() {
    return (this.paginationConfig.pageIndex - 1) * this.paginationConfig.pageSize;
  }

  getPaginationEnd() {
    return (this.paginationConfig.pageIndex - 1) * this.paginationConfig.pageSize + this.paginationConfig.pageSize;
  }
}



// WEBPACK FOOTER //
// ./src/app/main/organizations/organizations.component.ts